import { Box, CircularProgress } from '@mui/material';
import { styled } from '@mui/styles';
import { IconFilter } from 'assets/img';
import { LwButton } from 'redesign';

type Props = {
  nrOfActiveFilters: number;
  showSpinner?: boolean;
  onClick: () => void;
  disabled?: boolean;
};

const FilterButton = ({
  onClick,
  nrOfActiveFilters,
  showSpinner = false,
  disabled = false,
}: Props) => {
  return (
    <Box>
      <LwButton
        disabled={disabled}
        startIcon={showSpinner ? <CircularProgress size={24} /> : <IconFilter />}
        onClick={onClick}
        color="secondary"
        endIcon={
          nrOfActiveFilters ? (
            <Indicator aria-label="number-of-active-filters">{nrOfActiveFilters}</Indicator>
          ) : null
        }
      >
        Filter
      </LwButton>
    </Box>
  );
};

const Indicator = styled('span')(({ theme }) => ({
  fontSize: '12px !important',
  background: '#eee',
  borderRadius: theme.spacing(5),
  marginTop: theme.spacing(0.5),
  padding: theme.spacing(0, 2),
}));

export { FilterButton };
